require('./bytes-conversion')
require('./calc-age')
require('./currency')
require('./format-currency-by-id')
require('./date')
require('./human-date')
require('./nl2br')
require('./strip-tag')
require('./word-beautify')

// Getters from store
require('./store_getter/accessWayById')
require('./store_getter/currencyById')
require('./store_getter/lossReasonById')
require('./store_getter/productCategoryById')
require('./store_getter/segmentById')
require('./store_getter/sourceById')
require('./store_getter/memberById')
require('./store_getter/pipelineByStepId')
require('./store_getter/pipelineStepById')



// WEBPACK FOOTER //
// ./src/utils/filters/index.js